import { defineMessages } from 'react-intl';

// Label IDs intentionally reuse the email-modal translations so both modals
// share the same translated strings without duplicating the translation keys.
export default defineMessages({
  cancel: {
    id: 'email-modal.cancel',
    defaultMessage: 'Cancel',
  },
  send: {
    id: 'email-modal.confirm',
    defaultMessage: 'Send',
  },
  toLabel: {
    id: 'email-modal.to-label',
    defaultMessage: 'To',
  },
  subjectLabel: {
    id: 'email-modal.subject-label',
    defaultMessage: 'Subject',
  },
  messageLabel: {
    id: 'email-modal.message-label',
    defaultMessage: 'Message',
  },
});
